import { render } from "./box_collagen.vue?vue&type=template&id=7972ba5c"
import script from "./box_collagen.vue?vue&type=script&setup=true&lang=js"
export * from "./box_collagen.vue?vue&type=script&setup=true&lang=js"

import "./box_collagen.vue?vue&type=style&index=0&id=7972ba5c&lang=scss&scope=true"

import exportComponent from "C:\\essoduke\\Web\\health-click.dev\\app\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/js/hcv2/vue/views/campaign/luckybox/box_collagen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7972ba5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7972ba5c', __exports__)) {
    console.log('reload')
    api.reload('7972ba5c', __exports__)
  }
  
  module.hot.accept("./box_collagen.vue?vue&type=template&id=7972ba5c", () => {
    console.log('re-render')
    api.rerender('7972ba5c', render)
  })

}


export default __exports__